import React, { useState } from "react";
import LayoutHOC from "../LayoutHOC";
import Select from "../UniversalComponents/SelectComponent";
import Button from "../UniversalComponents/DefaultButton";
import Input from "../UniversalComponents/InputComponent";
import { ReactComponent as DownAngelBracket } from "../../assets/images/downAngleBracket.svg";
import DatePicker from "react-datepicker";
import { ReactComponent as CalendarWithTimeIcon } from "../../assets/images/calendarWithTimeIcon.svg";
import { CheckBox } from "@mui/icons-material";
import { Checkbox } from "@mui/material";
import TableComponent from "../UniversalComponents/TableComponent";
import CustomerHeaderHoc from "./CustomerHeaderHoc";

const RefundReceipt = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [shippingAddressValue, setshippingAddressValue] = useState("");
  const [billingAddressValue, setbillingaddressValue] = useState("");
  const [SalesReceiptDate, setSalesReceiptDate] = useState("");
  const [selected, setSelected] = useState("");

  const placeholder = "DD-MM-YYYY";
  const displayFormat = "dd-MM-yyyy";

  const handleSalesReceiptDate = (date) => {
    setSalesReceiptDate(date);
  };
  const handleButtonClickAddLines = () => {
    console.log("Add Lines button clicked");
    // Add your logic here
  };

  // Ensure this function is used correctly in the JSX
  <button onClick={handleButtonClickAddLines}>Add Lines</button>;

  const [InputValue, setInputValue] = useState("");

  const ClientOptions = [
    { label: "client 1", value: "client1" },
    { label: "client 2", value: "client2" },
  ];
  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleshippingAddressChange = (e) => {
    setshippingAddressValue(e.target.value);
  };

  const handlebillingAddressChange = (e) => {
    setbillingaddressValue(e.target.value);
  };
  const handleSelect = (option) => {
    setSelected(option);
  };

  return (
    <div className="mx-10">
      <div className=" mt-3 flex gap-5 items-start w-[100%] ">
        <div className=" border-[#DFE2E5] bg-white border rounded-md flex flex-wrap gap-3 p-2 w-[100%]">
          {/* First row */}
          <div className="w-[30%]  min-w-64">
            <label className="w-full text-14 text-434852 font-400 pb-1 ">Client</label>

            <Select
              placeholder={"Choose Client"}
              options={ClientOptions}
              value={selectedValue}
              onChange={handleSelectChange}
              style={{
                width: "100%",
                height: "35px",
                padding: "5px",
                color: "#AFAFAF",
                fontSize: "12px",
              }}
            />
          </div>

          <div className="w-[30%] min-w-64 ">
            <div className="w-full text-14 text-434852 font-400 pb-1 ">Email</div>
            <div>
              <Input
                name="emailInput"
                placeholder="Enter Email Address"
                value={InputValue}
                onChange={handleshippingAddressChange}
                style={{ width: "[100%]", height: "35px" }} // Additional styling if needed
              ></Input>
            </div>

            <div className="text-12 font-400 text-009CBF mt-1">Cc/Bcc</div>
          </div>

          <div className="w-[30%] min-w-64">
            <label className="w-full text-14 text-434852 font-400 pb-1 ">Billing address</label>

            <div>
              <Input
                name="billinginput"
                placeholder="Enter Biliing Address"
                value={InputValue}
                onChange={handlebillingAddressChange}
                style={{ width: "100%", height: "35px" }} // Additional styling if needed
              ></Input>
            </div>
          </div>

          {/* Second row  */}

          <div className="w-[30%] min-w-64 ">
            <div className=" w-full text-14 text-434852 font-400 pb-1">Refund Receipt Date</div>
            <div className="flex items-center bg-white border border-[#DFE2E5] datePicker_container rounded">
              <DatePicker
                selected={SalesReceiptDate}
                onChange={handleSalesReceiptDate}
                placeholderText={placeholder}
                dateFormat={displayFormat}
                className="bg-white border-[#DFE2E5]  w-[100%]   text-gray-800 text-sm block h-[35px] rounded "
              ></DatePicker>

              <div>
                <CalendarWithTimeIcon></CalendarWithTimeIcon>
              </div>
            </div>
          </div>
          <div className="w-[30%] min-w-64 ">
            <div className=" w-full text-14 text-434852 font-400 pb-1">Refund Receipt no.</div>
            <div>
              <Input
                name="billinginput"
                placeholder="Enter Refund Receipt no"
                value={InputValue}
                onChange={handlebillingAddressChange}
                style={{ width: "100%", height: "35px" }} // Additional styling if needed
              ></Input>
            </div>
          </div>
          <div className="w-[30%] min-w-64 ">
            <div className=" w-full text-14 text-434852 font-400 pb-1">Tags</div>
            <Select
              placeholder={"Select tags"}
              options={ClientOptions}
              value={selectedValue}
              onChange={handleSelectChange}
              style={{
                width: "100%",
                height: "35px",
                padding: "5px",
                color: "#AFAFAF",
                fontSize: "12px",
              }}
            />
          </div>

          {/*Third row  */}

          <div className="w-[30%] min-w-64 ">
            <div className="w-full text-14 text-434852 font-400 pb-1">Payment method</div>
            <Select
              placeholder={"Choose Payment method "}
              options={ClientOptions}
              value={selectedValue}
              onChange={handleSelectChange}
              style={{
                width: "100%",
                height: "35px",
                padding: "5px",
                color: "#AFAFAF",
                fontSize: "12px",
              }}
            />
          </div>

          <div className="w-[30%] min-w-64 ">
            <div className="w-full text-14 text-434852 font-400 pb-1">Refund From</div>
            <div className="flex items-center bg-white border border-[#DFE2E5] datePicker_container rounded">
              <Select
                placeholder={"Choose Client"}
                options={ClientOptions}
                value={selectedValue}
                onChange={handleSelectChange}
                style={{
                  width: "100%",
                  height: "35px",
                  padding: "5px",
                  color: "#AFAFAF",
                  fontSize: "12px",
                }}
              />
            </div>
          </div>
        </div>

        {/* Side section */}

        <div className="border-[#DFE2E5] bg-white border rounded-md justify-center flex items-center px-10 py-16 w-[20%]">
          <div className="flex flex-col bg-[#0093C1] gap-1 p-4 justify-center flex align items-center ">
            <span className="text-[#FFFFFF] text-16 font-400 text-nowrap">Available Amount</span>
            <span className="text-[#FFFFFF] text-30">$ 0.00</span>
          </div>
        </div>
      </div>

      <div>
        <TableComponent name="itemDetails" />
      </div>

      <div className="border-[#DFE2E5] bg-white border rounded-md p-4 mt-4">
        <div className="w-[60%]">
          <div className="flex gap-4">
            <div className="w-[50%]  ">
              <div>Message displayed on credit memo</div>
              <div className="h-[126px] text-14 font-400  border rounded"></div>
            </div>
            <div className="w-[50%]  ">
              <div>Message displayed on statement</div>
              <div className="h-[126px] text-14 font-400  border rounded"></div>
            </div>
          </div>
          <div className="flex gap-4">
            <div className="w-[50%]  ">
              <div>Attachments(0) Maximum Size 20 MB</div>
              <div className="h-[126px] text-14 font-400  border rounded"></div>
            </div>

            <div className="w-[50%]  ">
              <div>Uploaded Files</div>
              <div className="h-[126px] text-14 font-400  border rounded"></div>
            </div>
          </div>

          <div className="pt-2 text-12 font-400 text-009CBF">Show existing</div>
        </div>
      </div>

      {/* Fifth section */}

      <div className="flex justify-end w-full mt-4">
        <div className="border bg-[#F6FEFF] h-full w-1/4">
          <div className=" my-2 text-12">
            <div className=" border-b p-1 px-6">
              <div className="flex justify-between  items-center">
                <label className="text-1D4469   font-400">Sub Total</label>
                <span className="text-383838 font-500">$ 123.00</span>
              </div>
            </div>
            <div className="border-b items-center w-full text-12">
              <div className="flex flex-wrap justify-between px-4 md:px-6 items-center">
                <div className="flex flex-wrap space-y-0 md:space-y-0 md:space-x-3 w-full md:w-auto">
                  <div className="flex cursor-pointer items-center space-x-1">
                    <Checkbox
                      checked={selected === "percent"}
                      icon={<i className="bi bi-circle text-lg"></i>}
                      checkedIcon={<i className="bi bi-record-circle text-lg"></i>}
                      sx={{ padding: 0, height: "auto" }}
                      onChange={() => handleSelect("percent")}
                    />
                    <span className="text-[#1D4469] font-[400] text-12 md:text-base">Discount Percent</span>
                  </div>
                  <div className="flex cursor-pointer items-center space-x-1">
                    <Checkbox
                      checked={selected === "value"}
                      icon={<i className="bi bi-circle text-lg"></i>}
                      checkedIcon={<i className="bi bi-record-circle text-lg"></i>}
                      sx={{ padding: 0, height: "auto" }}
                      onChange={() => handleSelect("value")}
                    />
                    <span className="text-[#1D4469] font-[400] text-12 md:text-base">Discount Value</span>
                  </div>
                </div>

                <span className="text-[#383838] font-[500] whitespace-nowrap text-12 md:text-base">$ 123.00</span>
              </div>
            </div>

            <div className=" border-b p-2 px-6">
              <div className="flex justify-between  items-center">
                <label className="text-1D4469   font-400">Shipping</label>
                <span className="text-383838 font-500">$ 123.00</span>
              </div>
            </div>
            <div className=" border-b p-2 px-6">
              <div className="flex justify-between  items-center">
                <label className="text-1D4469   font-400">Total</label>
                <span className="text-383838 font-500">$ 123.00</span>
              </div>
            </div>
            <div className=" p-2 px-6">
              <div className="flex justify-between  items-center">
                <label className="text-1D4469   font-400">Total Credit</label>
                <span className="text-383838 font-500">$ 123.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Button Sections */}

      <div className=" flex justify-start items-center gap-x-4 mt-8 ">
        <div className="text-12 font-400 text-009CBF">Privacy</div>
        <div className="text-12 font-400 text-009CBF">Print or Preview</div>
        <div className="text-12 font-400 text-009CBF">Make Recurring</div>
      </div>
      <div className=" flex justify-end  ">
        <div className=" flex justify items-end space-x-2 mt-5">
          <Button type="primary" style={{ color: "#535252", height: "35px" }}>
            CANCEL
          </Button>
          {/* <Button type="primary" style={{ color: "#535252" }}>
            SAVE
          </Button> */}
          <Button type="secondary" style={{ height: "35px" }}>
            SAVE
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LayoutHOC(CustomerHeaderHoc(RefundReceipt));
